import { Avatar, AVATAR_HEIGHT_24 } from '../../../Avatar'
import { DashboardListRow } from '../../../DashboardBirdview'
import { useRentalPortalOverviewLink } from '../RentalPortalOverview.hooks'

import { OverviewApprovalActions } from './OverviewApprovalActions'
import { OverviewApprovalSubtitle } from './OverviewApprovalSubtitle'
import {
  getOverviewApprovalDecisionLink,
  getOverviewApprovalProfileLink,
} from './RentalPortalOverviewApprovalRow.utils'

import * as styles from './RentalPortalOverviewApprovalRow.module.css'

function RentalPortalOverviewApprovalRow({ row }) {
  const {
    handleClickLink: handleOpenProfile,
    handleMouseDownLink: handleMouseDownProfile,
  } = useRentalPortalOverviewLink({ link: getOverviewApprovalProfileLink(row) })
  const {
    handleClickLink: handleOpenDecision,
    handleMouseDownLink: handleMouseDownDecision,
  } = useRentalPortalOverviewLink({
    link: getOverviewApprovalDecisionLink(row),
  })

  return (
    <DashboardListRow
      Before={Avatar}
      Meta={OverviewApprovalActions}
      Subtitle={OverviewApprovalSubtitle}
      beforeProps={{
        className: styles.avatar,
        color: row.applicant_color,
        size: AVATAR_HEIGHT_24,
        text: row.applicant_display,
      }}
      metaProps={{
        row,
        onMouseDownDecision: handleMouseDownDecision,
        onMouseDownProfile: handleMouseDownProfile,
        onOpenDecision: handleOpenDecision,
        onOpenProfile: handleOpenProfile,
      }}
      subtitleProps={{ row }}
      title={row.applicant_display}
      onMouseDownTitle={handleMouseDownProfile}
      onOpen={handleOpenProfile}
    />
  )
}

export default RentalPortalOverviewApprovalRow
